import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  > .ant-card {
    .ant-card-head {
      border-bottom: 0;

      .ant-card-head-title {
        .ant-typography {
          margin-bottom: 0;
        }
      }
    }
  }
`

export default Styled
